import { useEffect } from "react";
import { usePayment } from "./usePayment";
export var useHandleGetClientToken = function (disabled, merchantAccountId, shippingMethodId, vaultPayment) {
    var handleGetClientToken = usePayment().handleGetClientToken;
    useEffect(function () {
        if (disabled)
            return;
        handleGetClientToken(merchantAccountId, vaultPayment);
    }, [disabled, shippingMethodId]);
};
